<template>
  <div class="animated fadeIn">
    <Forms ref="frmDefault"
      :title="'CADASTRO DE CONFGURAÇÕES DE WHATSAPP'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      :disabledKeyUpEnter="true"
      :isModal="isModal"
      v-on:Clear="onClear"
      v-on:Back="$emit('Back')"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-2">
          <label ><small v-if="form.nome.required" class="text-danger">*</small> Nome:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o nome do Parceiro do WhatsApp'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"
                          class="text-toupper"
            ></b-form-input>
          </div>
        </div>
        <!-- <div class="col-md-4">
          <label ><small v-if="form.url.required" class="text-danger">*</small> URL:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite a URL BASE da API'"
                          v-model="form.url.value"
                          :size="form.url.maxlength"
                          :required="form.url.required"
                          :state="form.url.state"
                          class="text-tolower"
            ></b-form-input>
          </div>
        </div> -->
        <div class="col-md-3">
          <label ><small v-if="form.usuario.required" class="text-danger">*</small> Usuário:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o nome do Usuário para Autenticação'"
                          v-model="form.usuario.value"
                          :size="form.usuario.maxlength"
                          :required="form.usuario.required"
                          :state="form.usuario.state"
            ></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label ><small v-if="form.senha.required" class="text-danger">*</small> Senha:</label>
          <div class="input-group">
            <b-form-input type="password"
                          :placeholder="'Digite a senha do Usuário para Autenticação'"
                          v-model="form.senha.value"
                          :size="form.senha.maxlength"
                          :required="form.senha.required"
                          :state="form.senha.state"></b-form-input>
          </div>
        </div>
      </div>

    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import WhatsAppRepository from '@/shared/http/repositories/configurations/whatsapp.js'
import WhatsAppModel from '@/shared/models/configurations/campanhawhatsappmodel.js'
import WhatsAppForms from './campanhawhatsappadd-form.js'

export default {
  name: 'WhatsAppConfigurationsAdd',
  mixins: [ActionsForm],
  props: {
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: WhatsAppModel,
      form: WhatsAppForms
    }
  },
  methods: {
    onLoad () {
    },
    onEdit (obj) {
      if (obj) {
        loading.push()
        Tools.SetValueInForm(this.form, this.data, obj)
        if (obj.tipo) {
          this.form.tipo.value = obj.tipo
        }

        loading.pop()
      }
    },
    onCreate () {
      loading.push()
      this.data.nome = this.form.nome.value
      WhatsAppRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.nome = this.form.nome.value
      WhatsAppRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/campaign/whatsapp/components/add/campanhawhatsappadd.vue